module.exports = __webpack_public_path__ + "static/media/empty-box.cce18ae7.svg";